/**
 * @name NewsImagesDialog
 * @description Modal para mostrar el detalle de la imagen de avisos
 * @author Alexis Becerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moment from 'moment';
import styled from 'styled-components';

import { Flex, Icons, MUI, Typography } from '@styles';

const NewsImagesDialog = (props) => {
  const {
    open,
    onClose,
    newSelected
  } = props;

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
    >
      <MUI.DialogTitle>
        {`${i18n.t('News.new')}`}
        <MUI.DialogBoxClose onClick={onClose}>
          <Icons.Close />
        </MUI.DialogBoxClose>
      </MUI.DialogTitle>
      <MUI.DialogContent>
        <Flex.Col>
          <MUI.Box padding="16px">
            {/* Image */}
            {newSelected.URLArchivo && (
              <Styled.CardImage>
                <Styled.Image src={newSelected.URLArchivo} />
              </Styled.CardImage>
            )}
            {/* Image - Default */}
            {!newSelected.URLArchivo && (
              <Styled.CardImageDefault>
                <Styled.ImageDefault src={'https://assets.talentry.io/icons/default/news-logo.png'} />
              </Styled.CardImageDefault>
            )}
          </MUI.Box>
          {/* Título & Fecha */}
          <Flex.Col flex="1" padding="8px">
            <Flex.Row alignItems="flex-start" padding="8px">
              <Typography.H5 style={{ flex: '1' }}>{newSelected.Titulo}</Typography.H5>
              <Typography.Text color="greyDarkAlpha" style={{ marginLeft: '12px' }}>{moment(newSelected.FechaInicio).format(i18n.t('FormatDates.short'))}</Typography.Text>
            </Flex.Row>
            {/* Descripción */}
            <Flex.Row padding="0 8px 8px">
              <Typography.Text style={{ flex: '1', whiteSpace: 'pre-line' }}>{newSelected.Mensaje}</Typography.Text>
            </Flex.Row>
          </Flex.Col>
        </Flex.Col>
      </MUI.DialogContent>
      <MUI.DialogActions>
        <MUI.ButtonText onClick={onClose}>
          {i18n.t('DialogConfirm.close')}
        </MUI.ButtonText>
      </MUI.DialogActions>
    </MUI.Dialog>
  );
};

NewsImagesDialog.propTypes = {
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta para cerrar el modal.
  onClose: PropTypes.func.isRequired,
  // Objeto de avisos.
  newSelected: PropTypes.object.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.CardImage = styled.div`
  width: 100%;
  height: 250px;
  border-radius: 6px;
`;

Styled.Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
`;

Styled.CardImageDefault = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 250px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  background-color: ${(props) => props.theme.colors.greyHover};
`;

Styled.ImageDefault = styled.img`
  height: 70px;
  width: auto;
  object-fit: cover;
  object-position: center;
`;


export default NewsImagesDialog;